import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import type { Id } from '@e-socna/data-layer';

import { formatDateTime } from '../utils/format-date-time.util';

import { JSONPretty } from './JSONPretty';
import { UserName } from './UserName';
import { Memo } from './Memo';

export interface Versioned<E extends object = object> {
  readonly _id: Id;
  readonly createdAt: string;
  readonly creatorId: Id;
  readonly automaticMemo?: string | null;
  readonly internalMemo?: string | null;
  readonly memo?: string | null;
  readonly version: E;
}

interface Props<E extends object = object> {
  readonly versions: readonly Versioned<E>[];
}

export const Versions = ({ versions }: Readonly<Props>) => (
  <Box sx={{ pt: 4, width: '100%' }}>
    {versions.map((version) => (
      <Accordion
        key={version._id}
        slotProps={{ transition: { unmountOnExit: true } }}
      >
        <AccordionSummary
          aria-controls={`panel-${version._id}-content`}
          expandIcon={<ExpandMoreIcon />}
          id={`panel-${version._id}-header`}
        >
          <Typography>
            {formatDateTime(version.createdAt)}, par{' '}
            <UserName id={version.creatorId} />
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Memo
            content={{
              auto: version.automaticMemo,
              internal: version.internalMemo,
              memo: version.memo,
            }}
            display={{
              auto: true,
              internal: true,
              memo: true,
            }}
          />
          <JSONPretty
            data={version.version}
            id={`json-pretty-${version._id}`}
          />
        </AccordionDetails>
      </Accordion>
    ))}
  </Box>
);
